// extracted by mini-css-extract-plugin
module.exports = {"typeImage":"styles_typeImage__25_lL","content":"styles_content__ix4jt"};